import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { WebsiteIndex, WebIngestionDto, IngestionResponse } from '../shared/interfaces';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WebService {
  private readonly http = inject(HttpClient);  
  private readonly apiUrl = environment.apiUrl;
  private readonly controller = 'web-ingestion'

  // Stato globale per bloccare l'interfaccia durante le operazioni lunghe
  isProcessing = signal<boolean>(false);

  /**
   * Recupera l'alberatura JSON completa: Indici -> Siti -> Pagine
   */
  getWebsites(): Observable<WebsiteIndex[]> {
    return this.http.get<WebsiteIndex[]>(`${this.apiUrl}/${this.controller}/sites`);
  }
  
  crawlWebsite(payload: WebIngestionDto): Observable<IngestionResponse> {
      return this.http.post<IngestionResponse>(`${this.apiUrl}/${this.controller}/crawl`, payload);
    }
}